import React, { ReactNode } from "react";
import { Result } from "antd";
import LoadingOutlined from "@ant-design/icons/LoadingOutlined";
import ContainerWithImageBg from "@components/ContainerWithImageBg";
import { AuthCard } from "../Card";

export const AuthLoading = ({
  title,
  subTitle,
}: {
  title?: ReactNode;
  subTitle?: ReactNode;
}) => {
  return (
    <ContainerWithImageBg
      align="center"
      justify="center"
      data-testid="container-with-bg"
    >
      <AuthCard data-testid="auth-card">
        <Result
          status="info"
          icon={<LoadingOutlined data-testid="loading-icon" spin />}
          title={title}
          subTitle={subTitle}
        />
      </AuthCard>
    </ContainerWithImageBg>
  );
};
